/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function BillIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "bill", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6 4.5C8.5 4.5 8.5 7.5 8.5 7.5V10M6 4.5C3.5 4.5 3.49999 7.5 3.49999 7.5V10H8.5M6 4.5L18 4.5C18 4.5 20.5 4.5 20.5 7.5C20.5 10.5 20.5 20.5 20.5 20.5L18.5 19.5L16.5 20.5L14.5 19.5L12.5 20.5L10.5 19.5L8.50001 20.5L8.5 10", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M11 10H17", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M11 13H15", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M11 16H17", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(BillIcon);
export default ForwardRef;
//# sourceMappingURL=billIcon.js.map